import AccountAggregation from '@client/models/store/accountAggregation';
// eslint-disable-next-line import/no-cycle
import aggregationService from '@client/services/aggregation';

const stateObj = () => new AccountAggregation();

const gettersObj = {
  aggregatedAccounts: (state) => state.accounts,
  aggregatedAccountsBalanceSum: (state, getters) => {
    let sum = 0;

    getters.aggregatedAccounts.forEach((account) => {
      sum += account?.balances?.current || 0;
    });

    return sum;
  },
};

const actions = {
  async loadAccountAggregation({rootGetters, dispatch}) {
    const userId = rootGetters['cognitoUser/userId'];

    // This method will call the overview load method to call the bff
    await dispatch('overview/getOverviewData', {userId}, {root: true});
  },
  async saveAggregatedInstitution(context, institution) {
    const data = await aggregationService.save(institution);

    // Reload the aggregated accounts
    context.dispatch('loadAccountAggregation');

    return data;
  },
};

const mutations = {
  setAccountAggregation(state, aggregationInfo) {
    state.assets = aggregationInfo.assets;
    state.liabilities = aggregationInfo.liabilities;
    state.accounts = aggregationInfo.accounts;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters: gettersObj,
  actions,
  mutations,
};
